<template>
    <BaseModal v-model="show" title="原图上传" :width="320">
        <input type="file" @change="setFile" @click="clear" ref="file"/>
        <a-row :gutter="20">
            <a-col span="12">
                <ResourceImg :id="photo['thumb_id']"/>
            </a-col>
            <a-col span="12">
                <img src="" id="selected" alt=""/>
            </a-col>
        </a-row>
        <div style="margin-top:30px;">
            <a-checkbox :checked="retouch" @change="setRetouch">已修图</a-checkbox>
            <a-button type="primary" icon="check" @click="submit"
                      :loading="loading" style="margin-left: 30px;">确认覆盖
            </a-button>
        </div>
    </BaseModal>
</template>

<script>
    import api from "../../../../../utils/api";
    import oss from "../../../../../utils/oss";
    import BaseModal from "../../../../../comps/BaseModal";
    import ResourceImg from "../../../../../comps/ResourceImg";

    export default {
        name: "Override",
        components: {ResourceImg, BaseModal},
        data() {
            return {
                show: false,
                file: {},
                photo: {},
                retouch: false,
                loading: false,
                thumb: {},
            }
        },
        methods: {
            async open(photo, thumb) {
                this.show = true;
                this.photo = photo;
                let data = await fetch(thumb);
                let blob = await data.blob();
                this.thumb = await this.blobToBase64(blob);
            },
            clear() {
                this.file = {};
                this.$refs.file.value = '';
                document.getElementById('selected').src = '';
            },
            async setFile(e) {
                this.file = e.target.files[0];
                let reader = new FileReader();
                reader.readAsDataURL(this.file);
                reader.onload = function (e2) {
                  document.getElementById('selected').src = e2.target['result'];
                }
            },
            setRetouch(e) {
                this.retouch = e.target.checked;
            },
            submit() {
              this.loading = true;
              this.doSubmit()
                  .then(() => {
                    this.show = false;
                    this.$message.success("覆盖上传成功，3秒后刷新查看！", 3, () => this.$emit("override"));
                  })
                  .catch(err => {
                    console.log(err);
                    this.$message.error(err ? err : "原图上传失败，请重试！");
                  })
                  .finally(() => this.loading = false);
            },
            async doSubmit() {
                const self = this;
                let first = await this.blobToBase64(this.file);
                let res = await api.v1.compare({
                    suffix_1: first[0], suffix_2: this.thumb[0],
                    content_1: first[1], content_2: this.thumb[1],
                });
                if (res['dist'] > 10) {
                    return Promise.reject("图片变化过大，无法上传");
                }
                let albumId = this.photo["album_id"];
                let memberId = this.photo["member_id"];
                let data = await oss.resize(this.file, 0);
                let args = {
                    type: "ORI", // 上传类型
                    orient: "0", // 旋转方向
                    file_name: self.file.name, // 图片名称
                    catch_time: self.file.last, // 拍摄时间
                    relate_id: self.photo.id, // 关联已上传ID
                    retouch: self.retouch ? "1" : "2", // 是否已修图
                };
                await oss.upload(albumId, memberId, data, args);
            },
            async blobToBase64(blob) {
                let reader = new FileReader();
                let blob2 = await oss.resize(blob, 128);
                return new Promise((resolve, reject) => {
                    reader.readAsDataURL(blob2);
                    reader.onload = function (e) {
                        let parts = e.target['result'].split(';base64,');
                        resolve([parts[0].split('/')[1], parts[1]]);
                    };
                    reader.onerror = reject;
                });
            }
        }
    }
</script>

<style scoped lang="less">
    img {
        max-width: 100%;
        margin-top: 30px;
    }
</style>
